import { CButton } from "@coreui/react";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import {FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit} from "@fortawesome/free-regular-svg-icons";

export const EditButton = ({className, ...props}) => {
    
    const {t} = useTranslation("Buttons");
    
    return (
        <CButton type="button" color="info" size="sm" className={classNames(className)} {...props}><FontAwesomeIcon icon={faEdit} className="mr-2"/>{t("edit")}</CButton>
    );
};


export default EditButton;